import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch (e) {
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    (async () => {
      if (localStorage.getItem("te_token")) {
        await refreshMe();
      }
      setLoading(false);
    })();
  }, [refreshMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.access_token) localStorage.setItem("te_token", data.access_token);
    if (data.refresh_token) localStorage.setItem("te_refresh", data.refresh_token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    if (data.access_token) localStorage.setItem("te_token", data.access_token);
    if (data.refresh_token) localStorage.setItem("te_refresh", data.refresh_token);
    setUser(data.user);
    return data.user;
  };

  const googleLogin = async (payload) => {
    const { data } = await api.post("/auth/google", payload);
    if (data.access_token) localStorage.setItem("te_token", data.access_token);
    if (data.refresh_token) localStorage.setItem("te_refresh", data.refresh_token);
    setUser(data.user);
    return data.user;
  };

  const phoneRequestOtp = async (phone) => {
    const { data } = await api.post("/auth/phone/request-otp", { phone });
    return data; // contains dev_code in demo mode
  };

  const phoneVerifyOtp = async ({ phone, code, name }) => {
    const { data } = await api.post("/auth/phone/verify-otp", { phone, code, name });
    if (data.access_token) localStorage.setItem("te_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* noop */ }
    localStorage.removeItem("te_token");
    localStorage.removeItem("te_refresh");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{
      user, setUser, loading,
      login, register, googleLogin,
      phoneRequestOtp, phoneVerifyOtp,
      logout, refreshMe, formatApiError,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
